
// // client/src/components/media/MediaPost.jsx
// import React, { useMemo, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import AppFooter from "../AppFooter";
// import { FaTimes, FaPaperPlane, FaArrowLeft } from "react-icons/fa";
// import PlatformSelector from '../PlatformSelector';

// function baseUrlFromReq(req) {
//   const envBase = (process.env.INTEGRATIONS_BASE_URL || process.env.BASE_URL || process.env.APP_URL || '').replace(/\/+$/, '');
//   if (envBase) return envBase;
//   const proto = (req.headers['x-forwarded-proto'] || req.protocol || 'https');
//   const host  = req.headers['x-forwarded-host'] || req.get('host');
//   return `${proto}://${host}`;
// }

// const IMG_EXT = new Set(['jpg','jpeg','png','gif','webp']);
// const VID_EXT = new Set(['mp4','mov','webm','mkv']);
// const extOf = (u='') => { try { return new URL(u).pathname.split('.').pop().toLowerCase(); } catch { return ''; } };


// // ---- helpers ---------------------------------------------------------------
// const isImageUrl = (u = "") => {
//   const clean = String(u).split("?")[0];
//   const ext = clean.includes(".") ? clean.split(".").pop().toLowerCase() : "";
//   return ["jpg", "jpeg", "png", "gif", "webp", "heic", "avif"].includes(ext);
// };

// const isVideoUrl = (u = "") => {
//   const clean = String(u).split("?")[0];
//   const ext = clean.includes(".") ? clean.split(".").pop().toLowerCase() : "";
//   return ["mp4", "m4v", "mov", "webm", "mkv"].includes(ext);
// };

// const detectKind = (urls = []) => {
//   const first = (urls[0] || "").toLowerCase().split("?")[0];
//   if (/\.(mp4|m4v)$/.test(first)) return "video";
//   if (/\.(mov|qt)$/.test(first))  return "mov";
//   if (/\.(jpg|jpeg|png|gif|webp|heic|avif)$/.test(first)) return "image";
//   return "";
// };

// // Treat absolute https://on-screen.app/public/... and relative /public/... as local
// const isLocalPublic = (u, base) => {
//   try {
//     const root = String(base).replace(/\/+$/, "");
//     const abs  = /^https?:\/\//i.test(String(u)) ? String(u) : `${root}/${String(u).replace(/^\/+/, "")}`;
//     const url  = new URL(abs);
//     return url.pathname.startsWith("/public/");
//   } catch { return false; }
// };

// export default function MediaPost() {
//   const { tenant, eventId, itemId } = useParams();
//   const { state } = useLocation();
//   const navigate = useNavigate();

//   const baseUrl =
//     process.env.REACT_APP_BASE_URL ||
//     window.location.origin ||
//     "http://localhost:5000";

//   // Normalize to absolute, publicly reachable URL (needed for IG/Bluesky/preview)
//   const toPublic = (u) => {
//     if (!u) return u;
//     const root = String(baseUrl).replace(/\/+$/, "");
//     if (/^https?:\/\//i.test(u)) return u;
//     if (u.startsWith("/public/")) return `${root}${u}`;
//     if (u.startsWith("/tenants/")) return `${root}/public${u}`;
//     // ensure spaces/utf8 are encoded
//     const combined = `${root}/${String(u).replace(/^\/+/, "")}`;
//     return encodeURI(combined);
//   };

//   // Convert an absolute/public path back to a server file path under /public
//   // (required by /api/youtube/upload which expects a local server path)
//   const toServerFilePath = (u) => {
//     if (!u) return null;
//     let pathname = u;
//     try {
//       if (/^https?:\/\//i.test(u)) {
//         const url = new URL(u);
//         pathname = url.pathname; // keep only the local path
//       }
//     } catch { /* leave pathname as-is */ }
//     if (pathname.startsWith("/tenants/")) pathname = `/public${pathname}`;
//     if (pathname.startsWith("/public/")) return pathname;
//     // Fallback: not a local asset (skip for YouTube uploads)
//     return null;
//   };

//   // ---------------- incoming defaults ----------------
//   const defaultText =
//     state?.content || state?.caption || state?.title || state?.description || "";

//   // Accept multiple shapes that upstream screens send
//   const fromStateImages =
//     (Array.isArray(state?.images) && state.images) ||
//     (Array.isArray(state?.media) && state.media) ||
//     (Array.isArray(state?.selectedMedia?.images) && state.selectedMedia.images) ||
//     (Array.isArray(state?.media?.images) && state.media.images) ||
//     [];

//   const fromStateVideos =
//     (Array.isArray(state?.videos) && state.videos) ||
//     (Array.isArray(state?.selectedMedia?.videos) && state.selectedMedia.videos) ||
//     (Array.isArray(state?.media?.videos) && state.media.videos) ||
//     [];

//   // Keep original order, unique
//   const unique = (arr) => Array.from(new Set((arr || []).filter(Boolean)));

//   const imagesRaw = useMemo(() => unique(fromStateImages), [fromStateImages]);
//   const videosRaw = useMemo(() => unique(fromStateVideos), [fromStateVideos]);

//   // Make absolute for posting/preview
//   const imagesAbsAll = useMemo(() => imagesRaw.map(toPublic), [imagesRaw]);
//   const videosAbs    = useMemo(() => videosRaw.map(toPublic), [videosRaw]);

//   // Strictly filter images for the "Images" section to avoid broken overlay on videos
//   const imagesAbs = useMemo(() => imagesAbsAll.filter(isImageUrl), [imagesAbsAll]);

//   // Server file paths for YouTube upload (local /public/... only)
//   const youtubeFilePaths = useMemo(
//     () => videosAbs.map(toServerFilePath).filter(Boolean),
//     [videosAbs]
//   );

//   // Bluesky supports images only (max 4)
//   const blueskyImages = useMemo(
//     () => imagesAbs.filter(isImageUrl).slice(0, 4),
//     [imagesAbs]
//   );

//   // ---------------- local state ----------------
//   const [content, setContent] = useState(defaultText);
//   const [busy, setBusy]       = useState(false);
//   const [error, setError]     = useState("");

//   // Default toggles preserved
//   const [platforms, setPlatforms] = useState({
//     instagram: false,
//     facebook:  false,
//     twitter:   false,
//     linkedin:  false,
//     bluesky:   false,
//     youtube:   false,
//     tiktok:    false,
//   });

//   const selected = useMemo(
//     () => Object.entries(platforms).filter(([, v]) => v).map(([k]) => k),
//     [platforms]
//   );

//   // ---------------- actions ----------------
//   const openBlueskyConnect = () => {
//     const url = `${baseUrl}/api/integrations/bluesky/login?tenantId=${Number(tenant || 1)}`;
//     window.open(url, "bsky-connect", "width=520,height=520,menubar=no,toolbar=no");
//   };

//   const ensureIgReady = async (tenantId) => {
//     const safeFetch = async (url) => {
//       try { const r = await fetch(url, { credentials: "include" }); return r.ok ? r.json() : null; }
//       catch { return null; }
//     };
//     const fbPeek = await safeFetch(`${baseUrl}/api/integrations/facebook/peek?tenantId=${tenantId}`);
//     let pages = Array.isArray(fbPeek?.pages) ? fbPeek.pages : [];
//     if (!pages.length) {
//       const igPeek = await safeFetch(`${baseUrl}/api/integrations/instagram/_peek?tenantId=${tenantId}`);
//       pages = Array.isArray(igPeek?.pages) ? igPeek.pages : [];
//     }
//     const eligible = pages.some((p) => p?.igUserId && (p?.hasPageToken || p?.pageToken));
//     if (!eligible) {
//       throw new Error(
//         "No connected Facebook/IG account for tenant. Go to Integrations → Facebook/Instagram and connect a Page linked to your IG."
//       );
//     }
//   };

//   const uploadToYouTube = async (tenantId) => {
//     if (!youtubeFilePaths.length) {
//       throw new Error("YouTube requires at least one local video under /public.");
//     }
//     const title = (content || "Upload").slice(0, 95);
//     const description = content || "";
//     for (const filePath of youtubeFilePaths) {
//       await axios.post(
//         `${baseUrl}/api/youtube/upload`,
//         { tenantId, title, description, privacyStatus: "unlisted", filePath },
//         { withCredentials: true, timeout: 5 * 60 * 1000 }
//       );
//     }
//   };

//   // --- helper: publish to Twitter directly (no backend file additions) ----
//   const publishToTwitter = async (tenantId, text, mediaUrls) => {
//     // Split into imageUrls / videoUrls using current URL helpers
//     const imageUrls = (mediaUrls || []).filter(isImageUrl);
//     const videoUrls = (mediaUrls || []).filter(isVideoUrl);

//     // Prefer unified Twitter publish; fallback to /tweet if not present
//     const paths = [
//       "/api/integrations/twitter/publish",
//       "/api/integrations/twitter/tweet",
//     ];

//     let lastErr, rsp;
//     for (const p of paths) {
//       try {
//         rsp = await axios.post(
//           `${baseUrl}${p}`,
//           { tenantId, text, imageUrls, videoUrls },
//           { withCredentials: true, timeout: 120000 }
//         );
//         break;
//       } catch (e) {
//         lastErr = e;
//       }
//     }
//     if (!rsp) {
//       const detail =
//         lastErr?.response?.data?.error ||
//         lastErr?.response?.data ||
//         lastErr?.message ||
//         "twitter publish failed";
//       throw new Error(
//         typeof detail === "string" ? detail : JSON.stringify(detail)
//       );
//     }
//     return rsp.data;
//   };

//   /**
//    * Post to LinkedIn
//    * Chooses appropriate endpoint based on media type
//    */
//   const postToLinkedIn = async () => {
//     const tenantId = Number(tenant);
//     const text = (content || '').trim();

//     const hasVideo = videosAbs.length > 0;
//     const hasImage = imagesAbs.length > 0;

//     // Video takes precedence
//     if (hasVideo) {
//       const videoUrl = videosAbs[0]; // Use first video
//       return axios.post(
//         `${baseUrl}/api/integrations/linkedin/publish-with-video`,
//         {
//           tenantId,
//           text,
//           videoUrl,
//           as: 'member' // Change to 'organization' when org posting is approved
//         },
//         { withCredentials: true, timeout: 60000 }
//       );
//     }

//     // Image if no video
//     if (hasImage) {
//       const imageUrl = imagesAbs[0]; // Use first image
//       return axios.post(
//         `${baseUrl}/api/integrations/linkedin/publish-with-image`,
//         {
//           tenantId,
//           text,
//           imageUrl,
//           as: 'member' // Change to 'organization' when org posting is approved
//         },
//         { withCredentials: true, timeout: 60000 }
//       );
//     }

//     // Text only
//     return axios.post(
//       `${baseUrl}/api/integrations/linkedin/publish`,
//       {
//         tenantId,
//         text,
//         as: 'member' // Change to 'organization' when org posting is approved
//       },
//       { withCredentials: true, timeout: 60000 }
//     );
//   };

//   /**
//    * Post to TikTok
//    * Sends video or image to TikTok as draft (Upload mode) or posts directly
//    */
//   const postToTikTok = async () => {
//     const tenantId = Number(tenant);
//     const caption = (content || '').trim();
    
//     // TikTok supports both video and images
//     const hasVideo = videosAbs.length > 0;
//     const hasImage = imagesAbs.length > 0;
    
//     if (!hasVideo && !hasImage && !caption) {
//       throw new Error('TikTok requires at least a video, image, or caption.');
//     }
    
//     // Use first video if available, otherwise first image
//     const mediaUrl = hasVideo ? videosAbs[0] : (hasImage ? imagesAbs[0] : null);
    
//     if (!mediaUrl) {
//       throw new Error('TikTok requires at least one video or image.');
//     }
    
//     return axios.post(
//       `${baseUrl}/api/integrations/tiktok/publish`,
//       {
//         tenantId,
//         mediaUrl,
//         caption,
//         mode: 'upload' // Send to TikTok Inbox as draft
//       },
//       { withCredentials: true, timeout: 60000 }
//     );
//   };

//   const submit = async () => {
//     try {
//       setBusy(true);
//       setError("");

//       if (!selected.length) throw new Error("Select at least one platform.");

//       const tenantId = Number(tenant) || 1;

//       // Build common payload for your hub route (others can accept video)
//       const mediaUrlsForOthers = unique([...videosAbs, ...imagesAbs]);

//       // Detect on what we actually send
//       const detected = detectKind(mediaUrlsForOthers);

//       // Map kind → backend expectations
//       const inferredKind =
//         detected === "video" ? "reel" :
//         detected === "image" ? "image" : "";

//       // Instagram validations (format & connection)
//       if (platforms.instagram) {
//         await ensureIgReady(tenantId);

//         // Only block MOV if it's NOT a local /public/... asset (server auto-transcodes locals)
//         if (detected === "mov") {
//           const first = mediaUrlsForOthers[0] || "";
//           if (!isLocalPublic(first, baseUrl)) {
//             throw new Error(
//               "Instagram only accepts MP4 (H.264 + AAC). Convert your MOV to MP4 or upload it to this app (under /public) so we can auto-convert."
//             );
//           }
//           // local MOV → allowed; backend will transcode
//         }

//         if (!mediaUrlsForOthers.length && !content.trim()) {
//           throw new Error("Instagram requires at least one image/video or a caption.");
//         }
//       }

//       // If multiple images selected, pass a simple carouselItems list
//       const igCarousel = imagesAbs.length > 1
//         ? imagesAbs.slice(0, 10).map((u) => ({ imageUrl: u }))
//         : undefined;

//       // Remove twitter and linkedin from the hub list (we'll call them directly)
//       const platformsForHub = selected.filter(
//         (p) => p !== "bluesky" && p !== "youtube" && p !== "twitter" && p !== "linkedin" && p !== "tiktok"
//       );

//       const payloadCommon = {
//         tenantId,
//         eventId:    eventId ? Number(eventId) : null,
//         eventItemId:itemId ? Number(itemId) : null,
//         platforms:  platformsForHub,
//         content,                    // keep for your other routes
//         caption: content,           // ensure instagramGraph receives caption text
//         mediaUrls: mediaUrlsForOthers,
//         kind: inferredKind,         // 'reel' | 'image' | '' (server also infers)
//         shareToFeed: true,
//         thumbOffsetSec: 0,
//         carouselItems: igCarousel,
//       };

//       // 1) Others via hub
//       if (payloadCommon.platforms.length) {
//         await axios.post(`${baseUrl}/api/integrations/publish`, payloadCommon, {
//           withCredentials: true,
//           timeout: 120000,
//         });
//       }

//       // 2) Twitter directly (bypasses generic hub to avoid "Platform not implemented")
//       if (platforms.twitter) {
//         await publishToTwitter(tenantId, content || "", mediaUrlsForOthers);
//       }

//       // 3) LinkedIn directly
//       if (platforms.linkedin) {
//         await postToLinkedIn();
//       }

//       // 4) YouTube (videos only, uses server file paths)
//       if (platforms.youtube) {
//         await uploadToYouTube(tenantId);
//       }

//       // 5) Bluesky (images only, up to 4)
//       if (platforms.bluesky) {
//         if (!content.trim() && blueskyImages.length === 0) {
//           throw new Error("Bluesky requires text or at least one image (video is not supported).");
//         }
//         await axios.post(
//           `${baseUrl}/api/integrations/bluesky/publish`,
//           { tenantId, text: content || "", mediaUrls: blueskyImages },
//           { withCredentials: true, timeout: 60000 }
//         );
//       }

//       // 6) TikTok (video or image to draft Inbox)
//       if (platforms.tiktok) {
//         await postToTikTok();
//       }

//       navigate(-1);
//     } catch (e) {
//       const msg =
//         e?.response?.data?.message ||
//         e?.response?.data?.error ||
//         e.message ||
//         "Failed to post";
//       setError(msg);
//     } finally {
//       setBusy(false);
//     }
//   };

//   const canSubmit =
//     selected.length > 0 &&
//     (content.trim().length > 0 || imagesAbs.length > 0 || videosAbs.length > 0);

//   // ---------------- render ----------------
//   return (
//     <div className="container py-3">
//       <h4 className="mb-3">Create Media Post</h4>

//       {/* Integrations - Dropdown Selector */}
//       <div className="mb-3">
//         <div className="form-label fw-semibold mb-2">Select Integrations</div>
//         <PlatformSelector
//           platforms={platforms}
//           setPlatforms={setPlatforms}
//           onConnect={(platformKey) => {
//             if (platformKey === 'bluesky') {
//               openBlueskyConnect();
//             }
//           }}
//           showConnectFor={['bluesky']}
//         />
//       </div>

//       {/* Content */}
//       <div className="mb-3">
//         <label className="form-label">Post Content</label>
//         <textarea
//           className="form-control"
//           rows={5}
//           value={content}
//           onChange={(e) => setContent(e.target.value)}
//         />
//       </div>

//       {/* Images */}
//       <div className="mb-3">
//         <div className="form-label">Images:</div>

//         {imagesAbs.length === 0 ? (
//           <div className="text-muted">No images provided.</div>
//         ) : (
//           <>
//             {/* HERO (full-width, responsive) */}
//             <div
//               className="border rounded mb-2"
//               style={{
//                 width: "100%",
//                 maxWidth: "100%",
//                 background: "#111",
//                 overflow: "hidden",
//               }}
//             >
//               <img
//                 src={imagesAbs[0]}
//                 alt=""
//                 style={{
//                   width: "100%",
//                   height: "auto",
//                   display: "block",
//                   objectFit: "contain",
//                 }}
//                 onError={(e) => (e.currentTarget.src = "/event.png")}
//               />
//             </div>

//             {/* Thumbnails (if more than one) */}
//             {imagesAbs.length > 1 && (
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns:
//                     "repeat(auto-fill, minmax(160px, 1fr))",
//                   gap: 10,
//                 }}
//               >
//                 {imagesAbs.slice(1).map((u, i) => (
//                   <div
//                     key={i}
//                     className="border rounded overflow-hidden"
//                     style={{ aspectRatio: "4 / 3", background: "#111" }}
//                   >
//                     <img
//                       src={u}
//                       alt=""
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                       onError={(e) => (e.currentTarget.src = "/event.png")}
//                     />
//                   </div>
//                 ))}
//               </div>
//             )}
//           </>
//         )}

//         {/* Bluesky hint */}
//         {platforms.bluesky && blueskyImages.length === 0 && !content.trim() && (
//           <div className="form-text mt-2">
//             Bluesky supports images (no video). Add at least one image or include
//             text.
//           </div>
//         )}
//       </div>

//       {/* Videos */}
//       {!!videosAbs.length && (
//         <div className="mb-3">
//           {/* <div className="form-label">
//             Videos (for Instagram/Twitter/LinkedIn/YouTube):
//           </div>
//           <div className="text-muted" style={{ fontSize: 13 }}>
//             YouTube uploads require local files under <code>/public</code>.
//             External URLs are skipped.
//           </div> */}
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
//               gap: 12,
//               marginTop: 8,
//             }}
//           >
//             {videosAbs.map((u, i) => (
//               <video key={i} src={u} controls style={{ width: "100%" }} />
//             ))}
//           </div>
//         </div>
//       )}

//       {!!error && <div className="alert alert-danger">{error}</div>}

//       <AppFooter
//         buttons={[
//           {
//             icon: <FaArrowLeft />,
//             label: "Back",
//             onClick: () => navigate(-1),
//           },
//           {
//             icon: <FaPaperPlane />,
//             label: busy ? "Posting…" : "Submit",
//             onClick: submit,
//             disabled: busy || !canSubmit,
//             type: "submit",
//           },
//         ]}
//       />
//     </div>
//   );
// }

// client/src/components/media/MediaPost.jsx
import React, { useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import AppFooter from "../AppFooter";
import { FaPaperPlane, FaArrowLeft } from "react-icons/fa";
import PlatformSelector from '../PlatformSelector';

// ---- helpers ---------------------------------------------------------------
const isImageUrl = (u = "") => {
  const clean = String(u).split("?")[0];
  const ext = clean.includes(".") ? clean.split(".").pop().toLowerCase() : "";
  return ["jpg", "jpeg", "png", "gif", "webp", "heic", "avif"].includes(ext);
};

const isVideoUrl = (u = "") => {
  const clean = String(u).split("?")[0];
  const ext = clean.includes(".") ? clean.split(".").pop().toLowerCase() : "";
  return ["mp4", "m4v", "mov", "webm", "mkv"].includes(ext);
};

const detectKind = (urls = []) => {
  const first = (urls[0] || "").toLowerCase().split("?")[0];
  if (/\.(mp4|m4v)$/.test(first)) return "video";
  if (/\.(mov|qt)$/.test(first))  return "mov";
  if (/\.(jpg|jpeg|png|gif|webp|heic|avif)$/.test(first)) return "image";
  return "";
};

// Treat absolute https://on-screen.app/public/... and relative /public/... as local
const isLocalPublic = (u, base) => {
  try {
    const root = String(base).replace(/\/+$/, "");
    const abs  = /^https?:\/\//i.test(String(u)) ? String(u) : `${root}/${String(u).replace(/^\/+/, "")}`;
    const url  = new URL(abs);
    return url.pathname.startsWith("/public/");
  } catch { return false; }
};

export default function MediaPost() {
  const { tenant, eventId, itemId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const baseUrl =
    process.env.REACT_APP_BASE_URL ||
    window.location.origin ||
    "http://localhost:5000";

  // Normalize to absolute, publicly reachable URL (needed for IG/Bluesky/preview)
  const toPublic = (u) => {
    if (!u) return u;
    const root = String(baseUrl).replace(/\/+$/, "");
    if (/^https?:\/\//i.test(u)) return u;
    if (u.startsWith("/public/")) return `${root}${u}`;
    if (u.startsWith("/tenants/")) return `${root}/public${u}`;
    // ensure spaces/utf8 are encoded
    const combined = `${root}/${String(u).replace(/^\/+/, "")}`;
    return encodeURI(combined);
  };

  // Convert an absolute/public path back to a server file path under /public
  // (required by /api/youtube/upload which expects a local server path)
  const toServerFilePath = (u) => {
    if (!u) return null;
    let pathname = u;
    try {
      if (/^https?:\/\//i.test(u)) {
        const url = new URL(u);
        pathname = url.pathname; // keep only the local path
      }
    } catch { /* leave pathname as-is */ }
    if (pathname.startsWith("/tenants/")) pathname = `/public${pathname}`;
    if (pathname.startsWith("/public/")) return pathname;
    // Fallback: not a local asset (skip for YouTube uploads)
    return null;
  };

  // ---------------- incoming defaults ----------------
  const defaultText =
    state?.content || state?.caption || state?.title || state?.description || "";

  // Accept multiple shapes that upstream screens send
  const fromStateImages =
    (Array.isArray(state?.images) && state.images) ||
    (Array.isArray(state?.media) && state.media) ||
    (Array.isArray(state?.selectedMedia?.images) && state.selectedMedia.images) ||
    (Array.isArray(state?.media?.images) && state.media.images) ||
    [];

  const fromStateVideos =
    (Array.isArray(state?.videos) && state.videos) ||
    (Array.isArray(state?.selectedMedia?.videos) && state.selectedMedia.videos) ||
    (Array.isArray(state?.media?.videos) && state.media.videos) ||
    [];

  // Keep original order, unique
  const unique = (arr) => Array.from(new Set((arr || []).filter(Boolean)));

  const imagesRaw = useMemo(() => unique(fromStateImages), [fromStateImages]);
  const videosRaw = useMemo(() => unique(fromStateVideos), [fromStateVideos]);

  // Make absolute for posting/preview
  const imagesAbsAll = useMemo(() => imagesRaw.map(toPublic), [imagesRaw]);
  const videosAbs    = useMemo(() => videosRaw.map(toPublic), [videosRaw]);

  // Strictly filter images for the "Images" section to avoid broken overlay on videos
  const imagesAbs = useMemo(() => imagesAbsAll.filter(isImageUrl), [imagesAbsAll]);

  // Server file paths for YouTube upload (local /public/... only)
  const youtubeFilePaths = useMemo(
    () => videosAbs.map(toServerFilePath).filter(Boolean),
    [videosAbs]
  );

  // Bluesky supports images only (max 4)
  const blueskyImages = useMemo(
    () => imagesAbs.filter(isImageUrl).slice(0, 4),
    [imagesAbs]
  );

  // ---------------- local state ----------------
  const [content, setContent] = useState(defaultText);
  const [busy, setBusy]       = useState(false);
  const [error, setError]     = useState("");

  // Default toggles preserved
  const [platforms, setPlatforms] = useState({
    instagram: false,
    facebook:  false,
    twitter:   false,
    linkedin:  false,
    bluesky:   false,
    youtube:   false,
    tiktok:    false,
    reddit:    false,
  });

  // Reddit-specific state
  const [redditSubreddits, setRedditSubreddits] = useState([]);
  const [redditSubreddit, setRedditSubreddit] = useState('');
  const [redditTitle, setRedditTitle] = useState('');

  const selected = useMemo(
    () => Object.entries(platforms).filter(([, v]) => v).map(([k]) => k),
    [platforms]
  );

  // Fetch Reddit subreddits when Reddit is toggled on
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useMemo(() => {
    if (platforms.reddit && redditSubreddits.length === 0) {
      const tenantId = Number(tenant) || 1;
      fetch(`${baseUrl}/api/integrations/reddit/subreddits?tenantId=${tenantId}`)
        .then(r => r.json())
        .then(data => {
          if (data.success && data.items) setRedditSubreddits(data.items);
        })
        .catch(err => console.error('Failed to fetch subreddits:', err));
    }
  }, [platforms.reddit]);

  // ---------------- actions ----------------
  const openBlueskyConnect = () => {
    const url = `${baseUrl}/api/integrations/bluesky/login?tenantId=${Number(tenant || 1)}`;
    window.open(url, "bsky-connect", "width=520,height=520,menubar=no,toolbar=no");
  };

  const ensureIgReady = async (tenantId) => {
    const safeFetch = async (url) => {
      try { const r = await fetch(url, { credentials: "include" }); return r.ok ? r.json() : null; }
      catch { return null; }
    };
    const fbPeek = await safeFetch(`${baseUrl}/api/integrations/facebook/peek?tenantId=${tenantId}`);
    let pages = Array.isArray(fbPeek?.pages) ? fbPeek.pages : [];
    if (!pages.length) {
      const igPeek = await safeFetch(`${baseUrl}/api/integrations/instagram/_peek?tenantId=${tenantId}`);
      pages = Array.isArray(igPeek?.pages) ? igPeek.pages : [];
    }
    const eligible = pages.some((p) => p?.igUserId && (p?.hasPageToken || p?.pageToken));
    if (!eligible) {
      throw new Error(
        "No connected Facebook/IG account for tenant. Go to Integrations → Facebook/Instagram and connect a Page linked to your IG."
      );
    }
  };

  const uploadToYouTube = async (tenantId) => {
    if (!youtubeFilePaths.length) {
      throw new Error("YouTube requires at least one local video under /public.");
    }
    const title = (content || "Upload").slice(0, 95);
    const description = content || "";
    for (const filePath of youtubeFilePaths) {
      await axios.post(
        `${baseUrl}/api/youtube/upload`,
        { tenantId, title, description, privacyStatus: "unlisted", filePath },
        { withCredentials: true, timeout: 5 * 60 * 1000 }
      );
    }
  };

  // --- helper: publish to Twitter directly (no backend file additions) ----
  const publishToTwitter = async (tenantId, text, mediaUrls) => {
    // Split into imageUrls / videoUrls using current URL helpers
    const imageUrls = (mediaUrls || []).filter(isImageUrl);
    const videoUrls = (mediaUrls || []).filter(isVideoUrl);

    // Prefer unified Twitter publish; fallback to /tweet if not present
    const paths = [
      "/api/integrations/twitter/publish",
      "/api/integrations/twitter/tweet",
    ];

    let lastErr, rsp;
    for (const p of paths) {
      try {
        rsp = await axios.post(
          `${baseUrl}${p}`,
          { tenantId, text, imageUrls, videoUrls },
          { withCredentials: true, timeout: 120000 }
        );
        break;
      } catch (e) {
        lastErr = e;
      }
    }
    if (!rsp) {
      const detail =
        lastErr?.response?.data?.error ||
        lastErr?.response?.data ||
        lastErr?.message ||
        "twitter publish failed";
      throw new Error(
        typeof detail === "string" ? detail : JSON.stringify(detail)
      );
    }
    return rsp.data;
  };

  /**
   * Post to LinkedIn
   * Chooses appropriate endpoint based on media type
   */
  const postToLinkedIn = async () => {
    const tenantId = Number(tenant);
    const text = (content || '').trim();

    const hasVideo = videosAbs.length > 0;
    const hasImage = imagesAbs.length > 0;

    // Video takes precedence
    if (hasVideo) {
      const videoUrl = videosAbs[0]; // Use first video
      return axios.post(
        `${baseUrl}/api/integrations/linkedin/publish-with-video`,
        {
          tenantId,
          text,
          videoUrl,
          as: 'member' // Change to 'organization' when org posting is approved
        },
        { withCredentials: true, timeout: 60000 }
      );
    }

    // Image if no video
    if (hasImage) {
      const imageUrl = imagesAbs[0]; // Use first image
      return axios.post(
        `${baseUrl}/api/integrations/linkedin/publish-with-image`,
        {
          tenantId,
          text,
          imageUrl,
          as: 'member' // Change to 'organization' when org posting is approved
        },
        { withCredentials: true, timeout: 60000 }
      );
    }

    // Text only
    return axios.post(
      `${baseUrl}/api/integrations/linkedin/publish`,
      {
        tenantId,
        text,
        as: 'member' // Change to 'organization' when org posting is approved
      },
      { withCredentials: true, timeout: 60000 }
    );
  };

  /**
   * Post to TikTok
   * Sends video or image to TikTok as draft (Upload mode) or posts directly
   */
  const postToTikTok = async () => {
    const tenantId = Number(tenant);
    const caption = (content || '').trim();
    
    // TikTok supports both video and images
    const hasVideo = videosAbs.length > 0;
    const hasImage = imagesAbs.length > 0;
    
    if (!hasVideo && !hasImage && !caption) {
      throw new Error('TikTok requires at least a video, image, or caption.');
    }
    
    // Use first video if available, otherwise first image
    const mediaUrl = hasVideo ? videosAbs[0] : (hasImage ? imagesAbs[0] : null);
    
    if (!mediaUrl) {
      throw new Error('TikTok requires at least one video or image.');
    }
    
    // For videos, optionally include a cover image (first available image)
    // This helps meet TikTok's picture_size_check requirements
    const coverImageUrl = hasVideo && imagesAbs.length > 0 ? imagesAbs[0] : null;
    
    return axios.post(
      `${baseUrl}/api/integrations/tiktok/publish`,
      {
        tenantId,
        mediaUrl,
        caption,
        mode: 'upload', // Send to TikTok Inbox as draft
        ...(coverImageUrl && { coverImageUrl }) // Include cover image if available
      },
      { withCredentials: true, timeout: 60000 }
    );
  };

  const submit = async () => {
    try {
      setBusy(true);
      setError("");

      if (!selected.length) throw new Error("Select at least one platform.");

      const tenantId = Number(tenant) || 1;

      // Check platform authorization before posting
      try {
        const statusRes = await fetch(
          `${baseUrl}/api/integrations/status/${tenantId}`,
          { headers: { 'Content-Type': 'application/json' } }
        );
        if (statusRes.ok) {
          const statusData = await statusRes.json();
          if (statusData.success) {
            const statuses = statusData.integrations || {};
            const unauthorized = selected.filter(p => !statuses[p]?.connected);
            if (unauthorized.length) {
              const names = unauthorized.map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(', ');
              toast.warn(`Please connect to ${names} before posting.`);
              navigate(`/${tenant}/integrations`);
              return;
            }
          }
        }
      } catch (err) {
        console.warn('[MediaPost] Could not verify platform authorization:', err.message);
      }

      // Build common payload for your hub route (others can accept video)
      const mediaUrlsForOthers = unique([...videosAbs, ...imagesAbs]);

      // Detect on what we actually send
      const detected = detectKind(mediaUrlsForOthers);

      // Map kind → backend expectations
      const inferredKind =
        detected === "video" ? "reel" :
        detected === "image" ? "image" : "";

      // Instagram validations (format & connection)
      if (platforms.instagram) {
        await ensureIgReady(tenantId);

        // Only block MOV if it's NOT a local /public/... asset (server auto-transcodes locals)
        if (detected === "mov") {
          const first = mediaUrlsForOthers[0] || "";
          if (!isLocalPublic(first, baseUrl)) {
            throw new Error(
              "Instagram only accepts MP4 (H.264 + AAC). Convert your MOV to MP4 or upload it to this app (under /public) so we can auto-convert."
            );
          }
          // local MOV → allowed; backend will transcode
        }

        if (!mediaUrlsForOthers.length && !content.trim()) {
          throw new Error("Instagram requires at least one image/video or a caption.");
        }
      }

      // If multiple images selected, pass a simple carouselItems list
      const igCarousel = imagesAbs.length > 1
        ? imagesAbs.slice(0, 10).map((u) => ({ imageUrl: u }))
        : undefined;

      // Reddit validation
      if (platforms.reddit) {
        if (!redditSubreddit) throw new Error("Please select a subreddit for your Reddit post.");
        if (!redditTitle.trim()) throw new Error("Reddit posts require a title.");
      }

      // Remove platforms that are called directly from the hub list
      const platformsForHub = selected.filter(
        (p) => p !== "bluesky" && p !== "youtube" && p !== "twitter" && p !== "linkedin" && p !== "tiktok" && p !== "reddit"
      );

      const payloadCommon = {
        tenantId,
        eventId:    eventId ? Number(eventId) : null,
        eventItemId:itemId ? Number(itemId) : null,
        platforms:  platformsForHub,
        content,                    // keep for your other routes
        caption: content,           // ensure instagramGraph receives caption text
        mediaUrls: mediaUrlsForOthers,
        kind: inferredKind,         // 'reel' | 'image' | '' (server also infers)
        shareToFeed: true,
        thumbOffsetSec: 0,
        carouselItems: igCarousel,
      };

      // 1) Others via hub
      if (payloadCommon.platforms.length) {
        await axios.post(`${baseUrl}/api/integrations/publish`, payloadCommon, {
          withCredentials: true,
          timeout: 120000,
        });
      }

      // 2) Twitter directly (bypasses generic hub to avoid "Platform not implemented")
      if (platforms.twitter) {
        await publishToTwitter(tenantId, content || "", mediaUrlsForOthers);
      }

      // 3) LinkedIn directly
      if (platforms.linkedin) {
        await postToLinkedIn();
      }

      // 4) YouTube (videos only, uses server file paths)
      if (platforms.youtube) {
        await uploadToYouTube(tenantId);
      }

      // 5) Bluesky (images only, up to 4)
      if (platforms.bluesky) {
        if (!content.trim() && blueskyImages.length === 0) {
          throw new Error("Bluesky requires text or at least one image (video is not supported).");
        }
        await axios.post(
          `${baseUrl}/api/integrations/bluesky/publish`,
          { tenantId, text: content || "", mediaUrls: blueskyImages },
          { withCredentials: true, timeout: 60000 }
        );
      }

      // 6) TikTok (video or image to draft Inbox)
      if (platforms.tiktok) {
        await postToTikTok();
      }

      // 7) Reddit (requires subreddit + title)
      if (platforms.reddit) {
        const hasImage = imagesAbs.length > 0;
        const hasVideo = videosAbs.length > 0;

        let endpoint = '/api/integrations/reddit/publish-text';
        const redditBody = { tenantId, subreddit: redditSubreddit, title: redditTitle, text: content || '' };

        if (hasImage) {
          endpoint = '/api/integrations/reddit/publish-image-from-url';
          redditBody.imageUrl = imagesAbs[0];
        } else if (hasVideo) {
          endpoint = '/api/integrations/reddit/publish-video-from-url';
          redditBody.videoUrl = videosAbs[0];
        }

        await axios.post(`${baseUrl}${endpoint}`, redditBody, { withCredentials: true, timeout: 120000 });
      }

      navigate(-1);
    } catch (e) {
      const msg =
        e?.response?.data?.message ||
        e?.response?.data?.error ||
        e.message ||
        "Failed to post";
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  const canSubmit =
    selected.length > 0 &&
    (content.trim().length > 0 || imagesAbs.length > 0 || videosAbs.length > 0);

  // ---------------- render ----------------
  return (
    <div className="container py-3">
      <h4 className="mb-3">Create Media Post</h4>

      {/* Integrations - Dropdown Selector */}
      <div className="mb-3">
        <div className="form-label fw-semibold mb-2">Select Integrations</div>
        <PlatformSelector
          platforms={platforms}
          setPlatforms={setPlatforms}
          onConnect={(platformKey) => {
            if (platformKey === 'bluesky') {
              openBlueskyConnect();
            }
          }}
          showConnectFor={['bluesky']}
        />
      </div>

      {/* Content */}
      <div className="mb-3">
        <label className="form-label">Post Content</label>
        <textarea
          className="form-control"
          rows={5}
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />
      </div>

      {/* Reddit-specific fields */}
      {platforms.reddit && (
        <div className="mb-3 p-3 rounded" style={{ background: '#fff4f0', border: '1px solid #FF4500' }}>
          <div className="fw-semibold mb-2" style={{ color: '#FF4500' }}>Reddit Post Settings</div>
          <div className="mb-2">
            <label className="form-label small mb-1">Subreddit *</label>
            <select
              className="form-select"
              value={redditSubreddit}
              onChange={(e) => setRedditSubreddit(e.target.value)}
            >
              <option value="">Select a subreddit...</option>
              {redditSubreddits.map((sr) => (
                <option key={sr.name} value={sr.name}>r/{sr.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="form-label small mb-1">Post Title *</label>
            <input
              type="text"
              className="form-control"
              value={redditTitle}
              onChange={(e) => setRedditTitle(e.target.value)}
              placeholder="Enter a title for your Reddit post"
              maxLength={300}
            />
            <div className="form-text">{redditTitle.length}/300 characters</div>
          </div>
        </div>
      )}

      {/* Images */}
      <div className="mb-3">
        <div className="form-label">Images:</div>

        {imagesAbs.length === 0 ? (
          <div className="text-muted">No images provided.</div>
        ) : (
          <>
            {/* HERO (full-width, responsive) */}
            <div
              className="border rounded mb-2"
              style={{
                width: "100%",
                maxWidth: "100%",
                background: "#111",
                overflow: "hidden",
              }}
            >
              <img
                src={imagesAbs[0]}
                alt=""
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "contain",
                }}
                onError={(e) => (e.currentTarget.src = "/event.png")}
              />
            </div>

            {/* Thumbnails (if more than one) */}
            {imagesAbs.length > 1 && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "repeat(auto-fill, minmax(160px, 1fr))",
                  gap: 10,
                }}
              >
                {imagesAbs.slice(1).map((u, i) => (
                  <div
                    key={i}
                    className="border rounded overflow-hidden"
                    style={{ aspectRatio: "4 / 3", background: "#111" }}
                  >
                    <img
                      src={u}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      onError={(e) => (e.currentTarget.src = "/event.png")}
                    />
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {/* Bluesky hint */}
        {platforms.bluesky && blueskyImages.length === 0 && !content.trim() && (
          <div className="form-text mt-2">
            Bluesky supports images (no video). Add at least one image or include
            text.
          </div>
        )}
      </div>

      {/* Videos */}
      {!!videosAbs.length && (
        <div className="mb-3">
          {/* <div className="form-label">
            Videos (for Instagram/Twitter/LinkedIn/YouTube):
          </div>
          <div className="text-muted" style={{ fontSize: 13 }}>
            YouTube uploads require local files under <code>/public</code>.
            External URLs are skipped.
          </div> */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
              gap: 12,
              marginTop: 8,
            }}
          >
            {videosAbs.map((u, i) => (
              <video key={i} src={u} controls style={{ width: "100%" }} />
            ))}
          </div>
        </div>
      )}

      {!!error && <div className="alert alert-danger">{error}</div>}

      {/* Desktop inline action bar (replaces footer on desktop) */}
      <div className="desktop-action-bar">
        <button type="button" onClick={() => navigate(-1)}>
          <FaArrowLeft /> Back
        </button>
        <button
          type="button"
          className="btn-primary-action"
          onClick={submit}
          disabled={busy || !canSubmit}
        >
          <FaPaperPlane /> {busy ? "Posting…" : "Submit"}
        </button>
      </div>

      <AppFooter
        buttons={[
          {
            icon: <FaArrowLeft />,
            label: "Back",
            onClick: () => navigate(-1),
          },
          {
            icon: <FaPaperPlane />,
            label: busy ? "Posting…" : "Submit",
            onClick: submit,
            disabled: busy || !canSubmit,
            type: "submit",
          },
        ]}
      />
    </div>
  );
}